<template>
  <div style="margin: 11px; background-color: white">
    <van-tabs @click="tabClick" v-model="currentIndex" :ellipsis="false">
      <van-tab
        v-for="(item, index) in categoryList"
        :title="item.name"
        :key="index"
      >
      </van-tab>
    </van-tabs>
    <div
      style="padding: 0 11px"
      :class="{ 'border-t': courseList.length == 0 }"
    >
      <courseCell
        :coursedata="courseList"
        :loading="listLoading"
        :finished="listFinished"
        :isdo="false"
        @footerRefresh="getcourse"
        @watchCourse="watchCourse"
      ></courseCell>
    </div>
  </div>
</template>

<script>
const pageSize = 10;
// let page=-1
// let currentIndex = 0;
import { getCategory, getCourse } from "@/api/apis";
import courseCell from "../viewcomponents/courseCell";
export default {
  name: "index",
  components: {
    courseCell,
  },
  data() {
    return {
      courseList: [],
      categoryList: [
        {
          name: "全部课程",
          id: "",
        },
      ], //课程列表

      currentCategoryId: 1000,
      listLoading: false,
      listFinished: false,
      jobIds: "", //职责id组
      page: 0, //页数
      currentIndex:0, //科目
    };
  },

  methods: {
    watchCourse(index) {
      console.log(index);
      this.$router.push({
        path: "/courseDetail",
        query: {
          courseId: this.courseList[index].id,
        },
      });
    },
    tabClick(name, title) {
      this.page = 0;
      // this.listLoading=true;
      this.currentIndex = name;
      console.log('name',name)
      this.courseList = [];
      this.listFinished = false;
      this.getcourse(name);
    },
    getcourse() {
      let that = this;
      if (that.listFinished) {
        return;
      }
      const params = {
        id: this.categoryList[this.currentIndex].id,
        enabled: true,
        page: this.page,
        size: pageSize,
        jobIds: that.jobIds,
      };
      if (that.listLoading) {
        return;
      }
      
      that.listLoading = true;
      getCourse(params)
        .then((res) => {
          let totalElements = res.totalElements;
          that.courseList = that.courseList.concat(res.content);
          if (res.content.length == 0) {
            that.listFinished = true;
          } else {
            that.listFinished = false;
            this.page++;
          }
          that.listLoading = false;
        })
        .catch((res) => {
          that.listLoading = false;
          that.listFinished = true;
        });
    },
  },
   created() {
    let jobIds = [];
    // 获取职责id
    
    let { currentIndex } = this.$route.query;
    let arr = "";
    if (this.$store.state.user.user.user) {
      arr = this.$store.state.user.user.user.jobs;
    }
    if (arr.length > 0) {
      arr.forEach((item) => jobIds.push(item.id));
      this.jobIds = jobIds;
    }

    //全部类别都显示
    let params = {
      enabled: true,
      page: 0,
      size: 50,
      sort: ["sort,asc", "id,desc"],
    };
    var that = this;
    getCategory(params)
      .then( (res) => {
        that.categoryList =  that.categoryList.concat(res.content);
        let { currentIndex } = this.$route.query;
      if (currentIndex) {
          this.currentIndex = currentIndex*1;
        this.getcourse()
        }
      })
      .catch((res) => {});
  },
  activated(){
      let { currentIndex } = this.$route.query;
      if (currentIndex&&currentIndex!=this.currentIndex) {
          this.listFinished=false
          this.currentIndex = currentIndex*1;
          this.courseList=[]
          this.page=0
        this.getcourse()
        }
  }
};
</script>

<style scoped>
.border-t {
  border-top: 1px solid #e5e5e5;
}
</style>
